module.exports = __webpack_public_path__ + "pc/img/main_swiper02.990580b0.jpg";